// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer';

import Vue from 'vue';

import breakpoint from '@/services/breakpoint';
import resizeMixin from '@/mixins/resize';

// Main app
import App1 from './App1Scope3.vue';
import App2 from './App2RoadmapDiamond.vue';

import '@/styles/main.scss';

// kick off the polyfill
smoothscroll.polyfill();

// register global mixin
Vue.mixin({
  beforeCreate() {
    this.$breakpoint = Vue.observable(breakpoint);
  },
  ...resizeMixin,
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App1),
}).$mount('#app-viz-scope3');

new Vue({
  render: (h) => h(App2),
}).$mount('#app-viz-roadmap-diamond')
